import { useContext } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import formatDateString from "../../../Util/functions/FormatDateString";
import formatTimeString from "../../../Util/functions/FormatTimeString";
import { getClientTimezoneName } from "../../../Util/functions/TimeZone";
const ProfileDetails = () => {
  const { userData } = useContext(AppContext);

  return (
    <div
      className="accountSettingsProfileContainer"
      key="Profile Details Container"
    >
      <h3 className="accountSettingsCardTitle accountSettinsProfileDetailsHeader">
        Profile Details
      </h3>
      <p className="accountSettingsProfileProperty">Name</p>
      <p className="accountSettingsProfileValue">
        {userData.CustomerFirstName} {userData.CustomerLastName}
      </p>
      <p className="accountSettingsProfileProperty">Username</p>
      <p className="accountSettingsProfileValue">{userData.CustomerUserName}</p>
      <p className="accountSettingsProfileProperty">Account Creation Date</p>
      <p className="accountSettingsProfileValue">
        {formatDateString(
          userData.DateCustCreated,
          userData.TimeZoneOverride
            ? getClientTimezoneName()
            : userData.TimeZone
        )}{" "}
        {formatTimeString(
          userData.DateCustCreated,
          userData.TimeZoneOverride
            ? getClientTimezoneName()
            : userData.TimeZone
        )}
      </p>
      <p className="accountSettingsProfileProperty">Demo</p>
      <p className="accountSettingsProfileValue">
        {userData.Demo ? "Yes" : "No"}
      </p>
      <p className="accountSettingsProfileProperty">Subscription Expiration</p>
      <p className="accountSettingsProfileValue">
        {formatDateString(
          userData.LicenseExpiration,
          userData.TimeZoneOverride
            ? getClientTimezoneName()
            : userData.TimeZone
        )}{" "}
        {formatTimeString(
          userData.LicenseExpiration,
          userData.TimeZoneOverride
            ? getClientTimezoneName()
            : userData.TimeZone
        )}
      </p>
    </div>
  );
};

export default ProfileDetails;
